module.exports = __webpack_public_path__ + "img/img_customers_01.42e4ba90.png";